module.exports = __webpack_public_path__ + "static/media/fightphase.b48767b3.png";